import { useState } from 'react';
import { toast } from 'sonner';
import { useRemoveUser } from 'src/hooks';
import { ToastStyled } from 'src/components/common';
import {
  InviteModal,
  Header,
  UsersListOrEmpty,
  CountAndLoadMore,
  KickUserModal,
} from '.';
import type { OrgMember } from 'src/types';

export const Users = () => {
  const [showInviteModal, setShowInviteModal] = useState<boolean>(false);

  // State for the modal
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<OrgMember | null>(null);

  const { mutate: removeUser, isPending: isRemovingUser } = useRemoveUser();

  // Handler for user actions that require confirmation
  const handleClickRemoveUser = (selectedUser: OrgMember) => {
    setSelectedUser(selectedUser);
    setShowConfirmDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    // should never happen but just in case
    if (!selectedUser) {
      toast.custom((t) => (
        <ToastStyled variant='error' handleClose={() => toast.dismiss(t)}>
          No user selected.
        </ToastStyled>
      ));
      return;
    }

    removeUser({
      id: selectedUser.id,
      email: selectedUser.email,
      status: selectedUser.status,
    });

    // Reset modal state
    setShowConfirmDeleteModal(false);
    setSelectedUser(null);
  };

  return (
    <div className='flex w-full flex-col items-center justify-center gap-2 gap-y-4 sm:gap-y-2 md:gap-4 md:gap-y-4'>
      <Header setShowInviteModal={setShowInviteModal} />

      <UsersListOrEmpty handleClickRemoveUser={handleClickRemoveUser} />

      <CountAndLoadMore />

      <KickUserModal
        show={showConfirmDeleteModal}
        setShow={setShowConfirmDeleteModal}
        handleConfirmDelete={handleConfirmDelete}
        selectedUser={selectedUser}
        isRemovingUser={isRemovingUser}
      />

      <InviteModal show={showInviteModal} setShow={setShowInviteModal} />
    </div>
  );
};
